// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../action-creators/busy-counter';
import {getFile, getFileRga} from '../repositories';
import {getStore} from '../../store-factory';

export const viewFile = async (file, rga = false) => {

    const dispatch = getStore().dispatch;

    dispatch(busyCounter.increaseBusyCounter());
    try {

        const response = rga ? await getFileRga(file) : await getFile(file);

        const blob = await response.blob();

        // Show preview of the file before download

        const previewUrl = URL.createObjectURL(blob);

        window.open(previewUrl, '_blank');

    } catch (error) {

    } finally {

        dispatch(busyCounter.decreaseBusyCounter());

    }

};



// WEBPACK FOOTER //
// ./src/shared/services/file-view.js